import { render, staticRenderFns } from "./QueueDetailDateDrawer.vue?vue&type=template&id=38dd422b&scoped=true"
import script from "./QueueDetailDateDrawer.vue?vue&type=script&lang=js"
export * from "./QueueDetailDateDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd422b",
  null
  
)

export default component.exports